import { createShortUid, logError } from '@amazon/vinyl-util'
import { ctx } from '../env/playbackContext'
import type { AdvertisementFields } from '../gql/advertisementFieldsFrag'
import type { PlaylistEntry } from './PlaylistController'

const { target } = ctx('advertisementToPlaylistEntry')

/** A free-tier queue's audio ad, played off its own url like any other queue entry. */
export function advertisementToPlaylistEntry(ad: AdvertisementFields): PlaylistEntry | null {
    const audioUrl = ad.playbackInformation?.audioUrl
    if (!audioUrl) {
        logError(target, 'advertisement missing audioUrl', ad.id)
        return null
    }
    return {
        id: ad.id ?? createShortUid(),
        entity: ad,
        title: ad.name ?? '',
        albumTitle: '',
        artistName: '',
        duration: 0,
        image: ad.image,
        trackLoadOptions: { type: 'src', uri: audioUrl },
    }
}
